import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./LegalPage.css";
import PrivacyPolicy from "./sections/PrivacyPolicy";
import TermsOfService from "./sections/TermsOfService";
import CookiePolicy from "./sections/CookiePolicy";
import GDPRPolicy from "./sections/GDPRPolicy";
import CaliforniaNotice from "./sections/CaliforniaNotice";

const LegalPage = () => {
  const [activeSection, setActiveSection] = useState("terms");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const section = params.get("section");
    if (section) {
      setActiveSection(section);
    }
  }, [location]);

  const renderSection = () => {
    switch (activeSection) {
      case "privacy":
        return <PrivacyPolicy />;
      case "cookies":
        return <CookiePolicy />;
      case "gdpr":
        return <GDPRPolicy />;
      case "california":
        return <CaliforniaNotice />;
      default:
        return <TermsOfService />;
    }
  };

  return (
    <div className="legal-page fade-in">
      <div className="legal-container">
        <h1>Legal Information</h1>
        <div className="legal-navigation">
          <button
            className={`legal-nav-button ${
              activeSection === "terms" ? "active" : ""
            }`}
            onClick={() => setActiveSection("terms")}
          >
            Terms of Use
          </button>
          <button
            className={`legal-nav-button ${
              activeSection === "privacy" ? "active" : ""
            }`}
            onClick={() => setActiveSection("privacy")}
          >
            Privacy Policy
          </button>
          <button
            className={`legal-nav-button ${
              activeSection === "cookies" ? "active" : ""
            }`}
            onClick={() => setActiveSection("cookies")}
          >
            Cookie Policy
          </button>
          <button
            className={`legal-nav-button ${
              activeSection === "gdpr" ? "active" : ""
            }`}
            onClick={() => setActiveSection("gdpr")}
          >
            GDPR
          </button>
          <button
            className={`legal-nav-button ${
              activeSection === "california" ? "active" : ""
            }`}
            onClick={() => setActiveSection("california")}
          >
            California Privacy Notice
          </button>
        </div>
        <div className="legal-content">{renderSection()}</div>
      </div>
    </div>
  );
};

export default LegalPage;
